// @flow
import type { JournalEntryHistoryEntry } from './types';

export const reconciliationOriginMap = {
  MANUAL: 'the Reconciler',
  FDS: 'the Financial Data Service',
  DP: 'Data Processing',
};

export const categorizationMethodMap = {
  CLIENT_RULE: 'Client Rule',
  GLOBAL_RULE: 'Global Rule',
  ML: 'ML Prediction',
  CLIENT_BASED_ML: 'Client-Based ML',
};

const getCreationOrigin = (reconciliationOrigin: string, categorizerMethod: string): string => {
  const reconciliationOriginText = reconciliationOriginMap[reconciliationOrigin];

  if (reconciliationOriginText) {
    return ` via ${reconciliationOriginText}`;
  }

  if (categorizerMethod) {
    return ` via the Reconciler`;
  }

  return '';
};

export const generateHistoryMessageText = ({
  to,
  from,
  message,
  reconciliationOrigin,
  categorizerMethod,
  categorizerLedgerName,
  categorizerPattern,
}: JournalEntryHistoryEntry) => {
  const isFromToChangeLog = to && from && message;
  if (isFromToChangeLog) {
    return `${message} from ${from} to ${to}.`;
  }

  const isCreationEntry = message && message.toLowerCase().includes('created');
  if (isCreationEntry) {
    let resultMessage = `Created a Journal Entry${getCreationOrigin(
      reconciliationOrigin,
      categorizerMethod,
    )}.`;

    if (categorizerMethod) {
      const categorizerMethodText = categorizationMethodMap[categorizerMethod] || 'None';
      const categorizerPatternText = categorizerPattern ? ` "${categorizerPattern}"` : '';

      resultMessage = `${resultMessage} Categorized to ${categorizerLedgerName} by ${categorizerMethodText}${categorizerPatternText}.`;
    }

    return resultMessage;
  }

  return message;
};
